import script from "./TableHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TableHeader.vue?vue&type=style&index=0&id=e3b347c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3b347c0"]])

export default __exports__